import { BaseControl } from "../base-control";

class TextareaControlCtrl extends BaseControl {
  constructor(BaseControlService, $scope, $element) {
    'ngInject';
    super(BaseControlService, $scope);
    this.$element = $element;
  }
  
  async initializeControlData() {
    await super.initializeControlData();
    if (this.isDynamic) return null;
    
    const lineHeightCss = this.$element[0].style.getPropertyValue('line-height') || '2.4vw';
    const heightMultiplier = Math.min(this.token.control.lineCount || 5, 5);
    const [ , val, units] = lineHeightCss.match(/^(\d+(?:\.\d+)?)(.*)$/);
    if (val && units) {
      const boxSize = (heightMultiplier * parseFloat(val)) + units;
      this.$element.height(boxSize);
    } else {
      this.$element.height('12vw');
    }
  }
  
  getMaxLength() {
    return this.token.control.maxLength;
  }
}

export default {
  bindings: {
    token: "<",
    model: "=",
    tabNumber: "<"
  },
  templateUrl: "fe-control/controls/textarea-control/textarea-control.component.html",
  controller: TextareaControlCtrl
};